<template>
  <div
    v-if="showDebug"
    style="position: fixed; z-index: 9000; opacity: 0.9; background: rgba(0, 0, 0, 0.9); padding: 10px"
  >
    <template
      v-for="(value, key) in settingsStore.state.value"
      :key="key"
    >
      <div
        style="cursor: pointer"
        :style="{ color: typeof value === 'boolean' ? 'yellow' : 'aquamarine' }"
        @click="toggleSetting(key)"
      >
        {{ key }}: {{ value }}
      </div>
    </template>
  </div>
  <div :data-loading="isLoading">
    <Notifications />
    <RouterView />
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import appStore from "@/store/app.js";
import authStore from "@/store/auth.js";
import emitenteStore from "@/store/emitente.js";
import settingsStore from "@/store/settings";

const isLoading = computed(() => appStore.loadingCount > 0);
const showDebug = ref(false);

const toggleSetting = (key) => {
  if (typeof settingsStore.state.value[key] === "boolean") {
    settingsStore.state.value[key] = !settingsStore.state.value[key];
  }
};

onMounted(async () => {
  appStore.state.loadingCount += 1;
  if (authStore.isAuthenticated()) {
    await Promise.all([
      authStore.currentUserRequest(),
      settingsStore.fetchSettings(),
      emitenteStore.getEmitenteId() ? emitenteStore.fetchEmitenteFromCookie() : null,
    ]);
  }
  appStore.state.loadingCount -= 1;
  appStore.state.mounted = true;

  window.addEventListener("keydown", (e) => {
    if (e.ctrlKey && e.altKey && e.code === "KeyD") {
      showDebug.value = !showDebug.value;
    }
  });
});
</script>

<style src="./style.scss" lang="scss"></style>
